const languages = [{code: 'en', title: 'ENG'}, {code: 'es', title: 'ESP'}];

const en = {
  languages,
  terms: 'terms',
  stories: 'stories',
  privacy: 'privacy',
  about: 'about',
  subtitle: 'Stories from the Lyft Driver Community',
  title: 'AMERICA IS AN IDEA, NOT a GEOGRAPHY.',
  titleBreak: 'AMERICA IS AN IDEA,<br>NOT a GEOGRAPHY.',
  readMore: 'Read More',
  continueTo: 'Continue to',
  continueToScroll: 'Continue to scroll and',
  readNext: 'Read the next story',
  watch: 'Watch The Video',
  pauseVideo: 'PAUSE VIDEO',
  playVideo: 'PLAY VIDEO',
  exploreStories: 'Explore Stories',
  introCopy:
    'Many of our drivers are immigrants, and many more are from immigrant families—all living in a nation founded by immigrants. These are some of their stories.'
};

const es = {
  languages,
  terms: 'términos',
  privacy: 'privacidad',
  stories: 'historias',
  about: 'conócenos',
  subtitle: 'Historias de la comunidad de conductores de Lyft',
  title: 'Estados Unidos: más que un país, es una idea.',
  titleBreak: 'Estados Unidos:<br>más que un país, es una idea.',
  readMore: 'Leer mÁs',
  continueTo: 'Continuar a',
  continueToScroll: 'CONTINÚA desplazando y',
  readNext: 'Lee la siguiente historia',
  watch: 'Ver el vídeo',
  pauseVideo: 'Pausar video',
  playVideo: 'Reproducir video',
  exploreStories: 'Explorar Historias',
  introCopy:
    'Muchos de nuestros conductores son inmigrantes y muchos más provienen de familias de inmigrantes, todos viviendo en una nación fundada por inmigrantes. Estas son algunas de sus historias.'
};

export default {en, es};
